// extracted by mini-css-extract-plugin
export default {"meinian-double-pie-attr-chart":"index_meinian-double-pie-attr-chart__agsOp","meinian-pie-center-text":"index_meinian-pie-center-text__xElw2"};